import "bootstrap/dist/css/bootstrap.min.css";
import MathTable from "components/tables/MathTable";
import React, { useEffect } from "react";
import { Card, Col } from "react-bootstrap";

const GNSSContinuityCard = ({ innerRef, data }) => {
  return (
    <>
      <Card.Title as="h6" ref={innerRef}>
        Continuity
      </Card.Title>
      <Card.Body>
        <p className="text-justify">
          Continuity represents the probability that healthy SIS per satellite
          will continue to be healthy without unscheduled interruptions over 14
          days.
        </p>

        <Col
          sm={{ span: 12, offset: 0 }}
          md={{ span: 5, offset: 0 }}
          xxl={{ span: 5, offset: 1 }}
        >
          <MathTable data={data.continuityTable} />
        </Col>
      </Card.Body>
    </>
  );
};

export default React.forwardRef((props, ref) => (
  <GNSSContinuityCard innerRef={ref} {...props} />
));
